function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { WhiteboardTool } from './WhiteboardTool';
import { Recognizer } from '../utils/Recognizer';
import { serializePath } from '../utils/paperjs';
export class CurveTool extends WhiteboardTool {
  constructor(enableToolEvent, modelGetter, shadowEmitter, scope) {
    super(enableToolEvent, modelGetter, shadowEmitter, scope);
    _defineProperty(this, "elementModel", null);
    _defineProperty(this, "recognizer", new Recognizer());
    _defineProperty(this, "pointCount", 0);
    _defineProperty(this, "pendingPoints", []);
    _defineProperty(this, "flushRafId", 0);
    _defineProperty(this, "showLiveCursor", true);
    _defineProperty(this, "flushPendingPoints", () => {
      this.flushRafId = 0;
      if (this.elementModel && this.pendingPoints.length > 0) {
        const appended = this.elementModel.appendPoints(this.pendingPoints);
        if (!appended) {
          this.resetStrokeState();
          return;
        }
        this.pendingPoints = [];
      }
    });
  }
  resetStrokeState() {
    this.pointCount = 0;
    this.pendingPoints = [];
    if (this.flushRafId) {
      cancelAnimationFrame(this.flushRafId);
      this.flushRafId = 0;
    }
    this.elementModel = null;
  }
  cancelCurrentAction() {
    this.resetStrokeState();
  }
  onMouseDown(_event) {
    const previousElement = this.elementModel;
    this.resetStrokeState();
    if (previousElement) {
      previousElement.dispose();
    }
    this.modelGetter().then(model => {
      if (model) {
        this.elementModel = model.createCurve(true);
      }
    });
  }
  onMouseDrag(event) {
    if (this.pointCount > 1024) {
      return;
    }
    const MIN_DISTANCE = 2;
    if (this.elementModel) {
      if (!this.elementModel.isAttached()) {
        this.resetStrokeState();
        return;
      }
      let lastX = 0;
      let lastY = 0;
      if (this.pendingPoints.length >= 2) {
        lastX = this.pendingPoints[this.pendingPoints.length - 2];
        lastY = this.pendingPoints[this.pendingPoints.length - 1];
      } else {
        const len = this.elementModel.points.length;
        if (len >= 2) {
          lastX = this.elementModel.points[len - 2];
          lastY = this.elementModel.points[len - 1];
        }
      }
      const dist = Math.max(Math.abs(lastX - event.point.x), Math.abs(lastY - event.point.y));
      if (dist >= MIN_DISTANCE) {
        this.pointCount += 1;
        this.pendingPoints.push(event.point.x, event.point.y);
        if (!this.flushRafId) {
          this.flushRafId = requestAnimationFrame(this.flushPendingPoints);
        }
      }
    }
  }
  onMouseUp(event) {
    if (this.flushRafId) {
      cancelAnimationFrame(this.flushRafId);
      this.flushRafId = 0;
    }
    this.flushPendingPoints();
    if (!this.elementModel || !this.elementModel.isAttached()) {
      this.resetStrokeState();
      return;
    }
    const currentElement = this.elementModel;
    const currentUuid = currentElement.uuid;
    const currentPointCount = this.pointCount;
    this.modelGetter().then(model => {
      if (!model) {
        return;
      }
      if (currentPointCount < 3) {
        model.removeElementItem(currentUuid);
      }
      if (currentElement.isAttached()) {
        currentElement.shadow = '';
      }
      // @ts-ignore
      if (currentElement.isAttached() && event.event.metaKey) {
        const result = this.recognizer.recognize(currentElement.points);
        if (result) {
          model.removeElementItem(currentUuid);
          if (/^rectangle/.test(result.shape)) {
            const rect = model.createRectangle(false);
            rect?.setPoints([result.minX, result.minY, result.maxX, result.maxY]);
          } else if (/^circle/.test(result.shape)) {
            const circle = model.createSegmentedPath('ellipse', false);
            const rect = new this.scope.Rectangle(new this.scope.Point(result.minX, result.minY), new this.scope.Point(result.maxX, result.maxY));
            const pathRect = new this.scope.Path.Ellipse(rect);
            const points = serializePath(pathRect);
            circle?.setPoints(points);
          } else if (/^triangle/.test(result.shape)) {
            const triangle = model.createTriangle(false);
            triangle?.setPoints([result.minX + (result.maxX - result.minX) / 2, result.minY, result.minX, result.maxY, result.maxX, result.maxY]);
          } else if (/^arrow/.test(result.shape)) {
            const arrow = model.createLinePath(false);
            arrow?.setPoints([result.minX, (result.maxY + result.minY) / 2, result.maxX, (result.maxY + result.minY) / 2]);
          }
        }
      }
      if (this.elementModel === currentElement) {
        this.resetStrokeState();
      }
    });
  }
}